import styled from 'styled-components'
import {
  Strong,
  Link,
  ChartTitle,
  ChartDescription,
  Button,
  Label,
} from '../styles'
import { HiMiniArrowUpRight } from 'react-icons/hi2'
import Dropdown from 'components/Dropdown'
import { BiChevronDown } from 'react-icons/bi'
import { ImCross } from 'react-icons/im'
import SVG from 'react-inlinesvg'
import svgSourceDesktopVd from '../../images/law-desktop-vd.svg'
import svgSourceMobileVd from '../../images/law-mobile-vd.svg'
import svgSourceDesktopGe from '../../images/law-desktop-ge.svg'
import svgSourceMobileGe from '../../images/law-mobile-ge.svg'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { csv } from 'd3'
import { useEffect } from 'react'
import votesData from './votes.csv'
import { useState } from 'react'

const texts = [
  {
    title: 'Trafic routier. Trajectoire de réduction pour le CO2',
    objectNumber: '19.3472',
    type: 'Motion',
    date: '17.06.2021',
    link: 'https://www.parlament.ch/fr/ratsbetrieb/suche-curia-vista/geschaeft?AffairId=20193472',
    author: 'Jürg Grossen (PVL)',
    yes: false,
    result: [95, 96]
  },
  {
    title: 'Pas de prescription pour les crimes les plus graves',
    objectNumber: '19.300',
    type: 'Initiative déposée par un canton',
    date: '06.01.2021',
    link: 'https://www.parlament.ch/fr/ratsbetrieb/suche-curia-vista/geschaeft?AffairId=20190300',
    author: 'St-Gall',
    yes: false,
    result: [89, 90]
  },
  {
    title: "Pour un calculateur en ligne des prix du carburant",
    objectNumber: '22.3884',
    type: 'Motion',
    date: '14.12.2022',
    link: 'https://www.parlament.ch/fr/ratsbetrieb/suche-curia-vista/geschaeft?AffairId=20190314',
    author: 'Sophie Michaud Gigon (Verts), Martin Schmid (PLR)',
    yes: true,
    result: [92, 91]
  },
]

export const LawPage = ({ title }: { title: string }) => {
  const [votes, setVotes] = useState<any[]>([])
  const [showMore, setShowMore] = useState(false)

useEffect(() => {
  console.log(votesData)
  csv(votesData).then((d: any) => {
    console.log(d)
    const v = d.map((row: any) => ({
      title: row.title,
      object: row.vote_object,
      objectNumber: '22.3884',
      type: 'Motion',
      date: row.date,
      link: 'https://www.parlament.ch/fr/ratsbetrieb/suche-curia-vista/geschaeft?AffairId=20190314',
      author: 'Sophie Michaud Gigon (Verts), Martin Schmid (PLR)',
      yes: true,
      result: [92, 91]
    }))
    console.log(v)
    setVotes(v)
  })
}, [])

  return (
    <Container>
      <TextWidth>
        <ChartTitle>Des votes à l'issue incertaine</ChartTitle>
        <ChartDescription>
          Votes de la dernière législature du Conseil national où un siège
          seulement aurait pu renverser la décision de la chambre.
        </ChartDescription>
      </TextWidth>
      <Content>
        {/* <InputTitle>
        Sans le groupe{' '}
        <Dropdown
          handleChange={(value) => {
            console.log(value)
          }}
          placeholder='Vaud'
          items={[
            { label: 'Vaud', value: 'vd' },
            { label: 'Genève', value: 'ge' },
          ]}
        />
      </InputTitle> */}
        {/* <img src={svgSource} style={{width: '100%', maxWidth: '1000px', margin: 'auto'}} /> */}
        {/* @ts-ignore */}
        {/* <div style={{ position: 'relative', width: '100%' }}>
          <Label
            style={{
              top: '5%',
              left: '85%',
              textAlign: 'right',
              transform: 'translateX(-100%)',
            }}
          >
            <b>64</b> votes se sont joués à{' '}
            <b style={{ whiteSpace: 'nowrap' }}>un siège</b> près
          </Label>
          <StyledSvg
            src={svgSourceDesktopVd}
            width={'100%'}
            height='auto'
            title='React'
          />
          <Label style={{ top: '45%', left: '30%', textAlign: 'right' }}>
            5'415
          </Label>

          <Label
            style={{
              top: '45%',
              left: '75%',
              textAlign: 'right',
              transform: 'translateX(-100%)',
            }}
          >
            <b>340</b> votes se sont joués à{' '}
            <b style={{ whiteSpace: 'nowrap' }}>dix sièges</b> près
          </Label>
        </div> */}

        <Pages>
          {texts.map((t) => (
            <Page>
              <PageBody>
                <PageHeader>
                  <Date>{t.date}</Date>
                </PageHeader>
                <PageContent>
                  <Type>{t.type}</Type>
                  <Title>{t.title}</Title>
                  <Link target='_blank' href={t.link}>
                    En lire plus <HiMiniArrowUpRight />
                  </Link>
                  <Line />
                  <Type>Déposé par</Type>
                  <Author>{t.author}</Author>
                </PageContent>
                <PageFooter>
                  <Type>Résultat du vote</Type>
                  <div><b>{t.result[0]}</b> Pour <b>{t.result[1]}</b> Contre</div>
                  <div><b>{t.yes ? 'Accepté' : <Rejected>Refusé</Rejected>}</b></div>
                </PageFooter>
              </PageBody>
            </Page>
          ))}
        </Pages>
        <Button onClick={() => {setShowMore(true)}}>
          <BiChevronDown style={{ fontSize: '1.5em', marginRight: '.25em' }} />{' '}
          En voir davantage
        </Button>
        {showMore && <VotesList>
          {votes.map(v => <div>{v.date} {v.title} {v.vote_object}</div>)}
        </VotesList>}
      </Content>
    </Container>
  )
}

// @ts-ignore
const StyledSvg = styled(SVG)`
  position: relative;

  g[id^='grey'] {
    rect {
      fill: ${({ theme }) => `rgb(${theme.grayColorLight})`};
    }
  }

  g[id^='color'] {
    rect,
    path {
      fill: ${({ theme }) => `rgb(${theme.colorMain})`};
    }
  }
`

const VotesList = styled.div`
  font-size: 0.65em;
  line-height: 1.2;
  margin-top: 40px;
  margin-bottom: 90px;
`

const InputTitle = styled.div`
  margin-bottom: 20px;
`
const Container = styled.div``

const Content = styled.div`
  margin: 0 auto 40px auto;
  padding: 20px;
  max-width: 1200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const pageElement = `
content: '';
position: absolute;
z-index: 0;
bottom: 9px;
left: 0;
width: 100%;
height: 20px;
border-bottom-left-radius: 2px;
border-bottom-right-radius: 2px;
box-shadow: 0 0 10px rgba(0,0,0,0.2);
`

const PageContent = styled.div``

const Rejected = styled.div`
  color: rgb(${({ theme }) => theme.colorMain});
`

const PageBody = styled.div`
  padding: 20px;
  font-size: 0.85em;
  background-color: rgb(${({ theme }) => theme.siteBackground});
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  max-width: 300px;
  min-height: 400px;
  min-width: 300px;
  flex-shrink: 0;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Author = styled.div`
  line-height: 1.4;
`

const PageHeader = styled.div``

const PageFooter = styled.div`
  //background-color: rgb(${({ theme }) => theme.colorMain});
  border-top: 1px solid rgb(${({ theme }) => theme.grayColorLight});
  padding-top: 20px;
`

const Pages = styled.div`
  padding-bottom: 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
`

const Page = styled.div`
  position: relative;
  border-right: 1px solid rgb(${({ theme }) => theme.grayColorLight});
  padding-right: 10px;
  margin-right: 10px;
  width: 100%;
  z-index: 1;

  &:last-child {
    margin-right: 0;
    border-right: none;
  }
`

const Type = styled.div`
  font-size: 0.65em;
  text-transform: uppercase;
  line-height: 1.2;
  margin-bottom: 0.5em;
`

const Date = styled.div``

const Title = styled.h3`
  font-family: var(--font-sans-serif);
  font-weight: 200;
  line-height: 1.4;
  font-size: 1em;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 0px;
`

const Line = styled.div`
  margin: 20px 0;
  border-bottom: 1px solid rgb(${({ theme }) => theme.grayColorLight});
`

const Number = styled.div`
  font-size: 1em;
  line-height: 1.4;
`

export default LawPage
